/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import {
    MyShowsUserSettings,
    MyShowsUserSettingsValue,
    OnePassAndRecordingsUserSettings,
    OnePassAndRecordingsUserSettingsValues,
} from 'client-code/user-settings';

//  TODO: This import to be taken from impls
import { UserSettingsServiceRepositoryImpl } from '../impls/UserSettingsServiceRepositoryImpl';
import { IUserSettingsService } from '../interfaces/IUserSettingsService';
import { TServicesParams } from '../types/TServicesParams';

export class UserSettingsService implements IUserSettingsService {
    private oUserSettingsServiceRepositoryImpl: UserSettingsServiceRepositoryImpl;

    public constructor(params: TServicesParams) {
        this.oUserSettingsServiceRepositoryImpl = new UserSettingsServiceRepositoryImpl(params);
    }

    public async getMyShowsUserSettings(): Promise<MyShowsUserSettings> {
        return this.oUserSettingsServiceRepositoryImpl.fetchMyShowsUserSettings();
    }

    public async setMyShowsUserSettings(value: MyShowsUserSettingsValue) {
        return this.oUserSettingsServiceRepositoryImpl.updateMyShowsUserSettings(value);
    }

    public async getOnePassAndRecordingsUserSettings(): Promise<OnePassAndRecordingsUserSettings> {
        return this.oUserSettingsServiceRepositoryImpl.fetchOnePassAndRecordingsSettings();
    }

    public async setOnePassAndRecordingsUserSettings(
        value: OnePassAndRecordingsUserSettingsValues,
    ) {
        return this.oUserSettingsServiceRepositoryImpl.updateOnePassAndRecordingsSettings(value);
    }
}
